import {
  type CategoryReview,
  GoalName,
  type ReviewInput,
  type Scalars,
} from '../__generated-gql-types__/globalTypes';

export const DEFAULT_REVIEW_FORM_VALUES = {
  anonymous: false,
  rate: 0,
  headline: null,
  comment: null,
};

interface Review {
  coach: { id: Scalars['CoachUrn']['output'] };
  anonymous: boolean;
  rate: number;
  comment?: Nullable<string>;
  headline?: Nullable<string>;
  categoryReviews?: Nullable<
    Array<
      Omit<CategoryReview, 'category' | 'subCategoryList'> & {
        category: {
          id: Scalars['CategoryUrn']['output'];
        };
      }
    >
  >;
}

export const convertReviewToReviewInput = (review: Review): ReviewInput => {
  return {
    coachUrn: review.coach.id,
    anonymous: review.anonymous,
    rate: review.rate,
    comment: review.comment,
    headline: review.headline,
    categoryReviews:
      review?.categoryReviews?.map((categoryReview) => {
        return {
          categoryUrn: categoryReview.category.id ?? '',
          knowledge: categoryReview.knowledge,
          value: categoryReview.value,
          responsiveness: categoryReview.responsiveness,
          supportiveness: categoryReview.supportiveness,
        };
      }) ?? null,
  };
};

export const RATE_TO_TEXT: Record<1 | 2 | 3 | 4 | 5, string> = {
  1: 'Poor',
  2: 'Below Average',
  3: 'Okay',
  4: 'Good',
  5: 'Great',
};

export const GOAL_TO_HEADINGS: Record<GoalName, string> = {
  [GoalName.SCHOOL]: 'Have you been admitted to any school yet?',
  [GoalName.CAREER]: 'Did you land a role yet?',
  [GoalName.TEST]: 'Share your test score:',
};
